export const questionnaireEvaluationInstanceCreator = (state) => {
    return {
        evaluationDocId: state.evaluationDocId,
        questionList: state.questionList,
        isSaveSuccess: state.isSaveSuccess,
        overrideScore: state.overrideScore,
        scoreData: {
            comment: '',
            score: ''
        }
    };
};
//# sourceMappingURL=QuestionnaireEvaluationInstanceCreator.js.map